import React from 'react';
import styled from '@emotion/styled';
import { useTheme, withTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import { Theme, ThemeProps } from '@theme/base';
import { TestId } from '@components/test-ids';
import { BaseBenefit } from '@components/benefits/benefit/base/BaseBenefit';
import { BenefitGroupComponent } from '@model/content';

export interface BenefitsRowProps extends BenefitGroupComponent {}

const Container = styled.div(({ theme }: ThemeProps) => ({
  backgroundColor: theme.custom.colors.group10.lighter,
  padding: `${theme.custom.spacing.xxLarge}px ${theme.custom.spacing.medium}px`,
  textAlign: 'center'
}));

const ContentContainer: any = styled.div(({ theme }: ThemeProps) => ({
  margin: '0 auto',
  maxWidth: theme.custom.contentSizes.maxContentWidth
}));

function getColumns(count: number) {
  switch (count) {
    case 4:
      return 3;
    case 3:
      return 4;
    default:
      return 4;
  }
}

export const BenefitsRowComponent = ({ benefits }: BenefitsRowProps) => {
  const theme: Theme = useTheme();
  const renderBenefits = () =>
    benefits.map((benefit) => (
      <Grid key={benefit.title} item xs={12} sm={6} md={getColumns(benefits.length)}>
        <BaseBenefit key={benefit.title} {...benefit} detail={benefit.details} />
      </Grid>
    ));
  return (
    <Container data-testid={TestId.benefitsRow}>
      <ContentContainer>
        <Grid container spacing={theme.custom.gridSpacing.default}>
          {renderBenefits()}
        </Grid>
      </ContentContainer>
    </Container>
  );
};

export const BenefitsRow = withTheme(BenefitsRowComponent);
